<template>
  <v-dialog transition="scale-transition" origin="center center" max-width="500" v-model="dialog"
    content-class="commission-tree">
    <template v-slot:activator="{ on, attrs }">
      <v-btn :ripple="false" v-bind="attrs" v-on="on" tile elevation="0" class="custom-btn" height="39" color="#039de9">
        Add Default Commission
      </v-btn>
    </template>
    <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
      <v-card-title class="pb-3 text-left justify-start pl-3">
        Add Default Commission
      </v-card-title>
      <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
        You Can Edit Default Commission From Here
      </v-card-subtitle>
      <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
        <v-row>
          <v-col cols="12">
            <fieldset>
              <legend>Tire</legend>
              <v-select solo :items="slots1" append-icon="mdi-chevron-down" label="Click to Select"
                class="custom-select" hide-details></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Level</legend>
              <v-select solo :items="slots2" append-icon="mdi-chevron-down" label="Click to Select"
                class="custom-select" hide-details></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Account Type</legend>
              <v-select solo :items="slots3" append-icon="mdi-chevron-down" label="Click to Select"
                class="custom-select" hide-details></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Currency Group</legend>
              <v-select solo :items="slots4" append-icon="mdi-chevron-down" label="Click to Select"
                class="custom-select" hide-details></v-select>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Commission $</legend>
              <v-text-field v-model="maxAllowance" label="Write Here" single-line solo hide-details
                class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
        </v-row>
      </v-card>
      <v-card-actions>
        <v-row dense>
          <v-col cols="12">
            <v-btn tile @click="dialog = false" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
              color="greenMain">Save</v-btn>
            <v-btn tile color="#FF567F" @click="dialog = false" elevation="0"
              class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      slots1: [1, 2, 3],
      slots2: ["Level 1", "Level 2", "Level 3"],
      slots3: ["Hero ACC", "B", "C"],
      slots4: ["Major", "B", "C"],
    };
  },
}; 
</script>
